import { Documentos } from 'src/app/models/documentos';
import { Component, OnInit, Inject, ɵLContext } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Acesso } from 'src/app/models/acesso';
import { Acompanhamento } from 'src/app/models/acompanhamento';
import { AcompanhamentoService } from 'src/app/services/acompanhamento.service';
import { DOCUMENT } from '@angular/common';

import { Criptografar } from 'src/app/util/criptografar';
import { FileSaverService } from 'ngx-filesaver';
import { ToastrService } from 'ngx-toastr';
import { UtilService } from 'src/app/services/util.service';

@Component({
  selector: 'app-acompanhamento',
  templateUrl: './acompanhamento.component.html',
  styleUrls: ['./acompanhamento.component.css']
})
export class AcompanhamentoComponent implements OnInit {

  public dtoAcompanhamento : Acompanhamento;
  public dtoAcesso!: Acesso;

  public textoAlocacao : string = '';

  public textoSpanDoc : string = ' [Ver Menos]';
  public exibirDocs : boolean = true;

  public textoMotivoRecusa: string='';

  documentoCotistaForm: FormGroup | any;
  docs: FormGroup | any;
  habilitarBtnEnviar: boolean = false;

  public v_situacaoInscricao : string ='';

  constructor(private route : ActivatedRoute,
              private router : Router,
              public objServiceApi : AcompanhamentoService,
              @Inject(DOCUMENT) document: Document,
              private filesaverservice : FileSaverService,
              private toastr: ToastrService,
              protected utilService: UtilService,
              private fb: FormBuilder){
    this.dtoAcompanhamento = new Acompanhamento();
  }

  ngOnInit(): void {

      let objCipto : Criptografar = new Criptografar();
      this.dtoAcesso = JSON.parse(objCipto.decrypt(this.route.snapshot.queryParams['n']));

      this.documentoCotistaForm = new FormGroup({
        IR: new FormControl(false,),
        DESEMPREGADO: new FormControl(false)
      });

      this.getAcompanhamento();
  }

  Enviar(){

    const listDocs = this.docs.get('DocumentoCotista').value as Array<Documentos>;
    this.dtoAcompanhamento.documentos=listDocs;
    this.objServiceApi.enviarDocs(this.dtoAcompanhamento)
    .subscribe((retorno) => {
      if(retorno.realizada == true){
        this.toastr.success('Envio realizado com sucesso', 'Aviso');
        this.docs.reset();
        this.getAcompanhamento();
        this.validatorsField();
      }else if (retorno.msgErro != ''){
        this.toastr.error(retorno.msgErro, 'Aviso');
      }
    });
  }

  obterDocPeloIndex(index: number): any {
    let controlArray = <FormArray>this.docs.get('DocumentoCotista');
    return controlArray.at(index);
  }

  validaTamanhoArquivo(arquivo: File): boolean{
    if(arquivo.size > 2097152){
      this.toastr.error('Tamanho superior a 2 Megabytes.', 'Arquivo Inválido');
      return false;
    } else  {
      return true;
    }
  }

  validaTipoArquivo(arquivo: File, descDoc: string, codDoc: any): boolean{
      this.toastr.toastrConfig.enableHtml=true;
      if (parseInt(codDoc) === 14 || descDoc.substring(0,10).toLocaleUpperCase() === 'FOTOGRAFIA') { //FOTO 3 X 4
        if (arquivo.type.toString() !== 'image/jpeg' && arquivo.type.toString() !== 'image/jpg') {
          this.toastr.error('Formato do arquivo não suportado.</br>'
                            +'Somente <b>JPG</b> ou <b>JPEG</b> é suportado.', 'Arquivo Inválido');
          return false;
        }
        else {
              return true;
        }
      }

      switch(arquivo.type) {
        case 'application/pdf':
          return true;
        default:
          this.toastr.error('Formato do arquivo não suportado.</br>Somente <b>PDF</b> é suportado.', 'Arquivo Inválido');
          return false;
      }
  }

  showProgress(arquivo: File){
    this.toastr.info('Carregando', arquivo.name, {
      'extendedTimeOut': 1000,
      'timeOut': 1000,
      'enableHtml': true,
      'tapToDismiss': false,
      'progressBar': true,
      'progressAnimation': 'increasing'
    });
  }

  validatorsField() {

    const result = this.docs.get('DocumentoCotista').value as Array<Documentos>;
    this.habilitarBtnEnviar = false;
    if (result.length > 0){

      //this.habilitarBtnEnviar = result.every(doc => doc.fileBase64 != '' && doc.fileBase64 != undefined)

      this.docs.get('DocumentoCotista').controls.forEach((group: FormGroup<any>) => {
 
        let controle = group.get('fileBase64') as FormControl;

        /* if(this.habilitarBtnEnviar === false){
          controle.setValidators([Validators.required]);
          controle.updateValueAndValidity();
        } else{
          controle.setValidators([]);
          controle.updateValueAndValidity();
        } */
      
        if (controle.value !== '' && controle.value !== undefined && controle.value !== null ){
          this.habilitarBtnEnviar = true;
        }
      });
    } 
    else {
      this.habilitarBtnEnviar = false;
    }
  }

  inserirString64(doc: any, binaryString: any, e: any){
   
    doc.patchValue({
      carregandoDocumento: false,
        fileBase64: btoa(binaryString),
        loadSymbol: false,
        nomeArquivo: e.files[0].name
    });
  }

  habilitaBtnEnviar() {
   
    //if (this.documentoCotistaForm !== undefined){
      //return (!this.documentoCotistaForm.valid || !this.habilitarBtnEnviar);
      return this.habilitarBtnEnviar;
    //}else{
    //  return false;
    //}
  }

  uploadFile(e: any){
 
    if(e.files[0])
    {
      const indexDocumento = e.index;
      const arquivo = e.files[0];
      const documento: FormGroup = this.obterDocPeloIndex(indexDocumento);
      const descDoc = documento.value.descDoc;//documento.value.descDoc.substring(0,10);
      const codDoc = documento.value.codDoc;

      if(this.validaTamanhoArquivo(arquivo) && this.validaTipoArquivo(arquivo, descDoc,codDoc))
      {
        var reader = new FileReader();

        reader.readAsBinaryString(arquivo);
        this.showProgress(arquivo);
        reader.onloadend = (event: any) =>
        {
          const binaryString = event.target.result;
          this.inserirString64(documento, binaryString, e);
          this.validatorsField();
        }
      } else {
        e.event.srcElement.value = null;
        documento.patchValue(
          { documento: {
            nomeArquivo: 'Selecione o Arquivo'
        }});
      }
    }
    else{
  
      const indexDocumento = e.index;
      const documento: FormGroup = this.obterDocPeloIndex(indexDocumento);
      documento.controls["nomeArquivo"].setValue(null);
      documento.controls["nomeArquivo"].updateValueAndValidity();
      documento.controls["fileBase64"].setValue(null);
      documento.controls["fileBase64"].updateValueAndValidity();
      this.validatorsField();
    }
  }

  mostrarEsconderDoc(){

    if(this.exibirDocs==false){
      this.exibirDocs=true;
      this.textoSpanDoc='[Ver Menos]';
    }else if(this.exibirDocs==true){
      this.exibirDocs=false;
      this.textoSpanDoc='[Ver Mais]';
    }
  }

  redirecionarPrematricula(){

    let a= document.createElement('a');
        a.target= '_blank';
        a.href= this.dtoAcompanhamento.urlPreMatricula;
        a.click();
  }

  paginaAnterior(){
    //window.history.back();
    this.router.navigate(['/home']);
  }

  retornaDiaExtenso(dia : number) {
    var ArraySemana = new Array(6);
    ArraySemana[0] = 'Domingo';
    ArraySemana[1] = 'Segunda-Feira';
    ArraySemana[2] = 'Terça-Feira';
    ArraySemana[3] = 'Quarta-Feira';
    ArraySemana[4] = 'Quinta-Feira';
    ArraySemana[5] = 'Sexta-Feira';
    ArraySemana[6] = 'Sábado';
    return ArraySemana[dia];
  }

  getAcompanhamento(){
    this.utilService.showLoading();
    this.objServiceApi.getAcompanhamento(this.dtoAcesso.cpf,this.dtoAcesso.inscricao)
    .subscribe((retorno) => {

      this.dtoAcompanhamento = retorno;

      if(this.dtoAcompanhamento.indCotista == true){//Cotistas
        if(this.dtoAcompanhamento.indVista){//Já foi liberada a vista de deferimento ou indeferimento
          this.v_situacaoInscricao=' - '+this.dtoAcompanhamento.situacao;
        }else{
          this.v_situacaoInscricao='';
        }
      }else{//Ampla Concorrência
        this.v_situacaoInscricao=' - '+this.dtoAcompanhamento.situacao;
      }

      if(this.dtoAcompanhamento.autorizaSMS){
        document.getElementById('chksms')?.setAttribute('checked','true');
      }else{
        document.getElementById('chksms')?.removeAttribute('checked');
      }

      if(this.dtoAcompanhamento.autorizaInfoPos){
        document.getElementById('chkpos')?.setAttribute('checked','true');
      }else{
        document.getElementById('chkpos')?.removeAttribute('checked');
      }

      //Isento de irpf
      const controleIr : FormControl = this.documentoCotistaForm.get('IR');
      controleIr.disable({ onlySelf: true })
      if(this.dtoAcompanhamento.isIsentoIrpf){        
        controleIr.setValue(true);
      }else{
        controleIr.setValue(false);
      }

      //está desempregado
      const controleDesempregado: FormControl = this.documentoCotistaForm.get('DESEMPREGADO');
      controleDesempregado.disable({ onlySelf: true })
      if(this.dtoAcompanhamento.isDesempregado){
        controleDesempregado.setValue(true);
      }else{
        controleDesempregado.setValue(false);
      }

      //tratativas para mostrar texto de alocação de candidatos.
      if(this.dtoAcompanhamento.situacao === 'INSCRIÇÃO CONFIRMADA'){
        if(this.dtoAcompanhamento.existeAlocacao){
          if(this.dtoAcompanhamento.alocado){
            var data = this.dtoAcompanhamento.dataProva.split("/");
            var dtformatada = new Date(parseInt(data[2]), (parseInt(data[1]) - 1), parseInt(data[0]));
            if(this.dtoAcompanhamento.sala == '00' || this.dtoAcompanhamento.sala == '99'){//Códigos para definir que é prova on-line.
              this.textoAlocacao = "Sua prova será realizada de forma on-line, no dia " +
                                    this.dtoAcompanhamento.dataProva +", das " +
                                    this.dtoAcompanhamento.horaInicioProva + "h às " +
                                    this.dtoAcompanhamento.horaFimProva + "h - " +
                                    this.retornaDiaExtenso((dtformatada).getDay()) +
                            ",&nbsp;<a href='" + this.dtoAcompanhamento.descricaoSala + "' target='_blank' id='lnkProvaOnline'>Acessar a prova.</a>";
            }else{
              this.textoAlocacao = 'Sua prova será realizada na ' + this.dtoAcompanhamento.instituicao + ', ' +
                                  (this.dtoAcompanhamento.endereco != '' ? this.dtoAcompanhamento.endereco + ', ' : '') +
                                  this.dtoAcompanhamento.descricaoSala + ', ' + parseInt(this.dtoAcompanhamento.andar) +
                                  'º andar, no dia ' + this.dtoAcompanhamento.dataProva +', das ' +
                                  this.dtoAcompanhamento.horaInicioProva + 'h às ' + this.dtoAcompanhamento.horaFimProva + 'h - ' +
                                  this.retornaDiaExtenso((dtformatada).getDay()) + '.';
            }
          }else{
            this.textoAlocacao = 'Será divulgado a partir das ' +
                               this.dtoAcompanhamento.horaDivulgacao + 'h do dia ' +
                               this.dtoAcompanhamento.dataDivulgacao + ' na página da EMERJ.';
          }
        }else{
          this.textoAlocacao = 'Será divulgado a partir das ' +
                               this.dtoAcompanhamento.horaDivulgacao + 'h do dia ' +
                               this.dtoAcompanhamento.dataDivulgacao + ' na página da EMERJ.';
        }
      }

      //Tratativas para exibir o boleto.
      if(this.dtoAcompanhamento.indCotista && this.dtoAcompanhamento.indIsentoTaxa){
        //Aqui não apresentamos boleto para cotista e que foram deferidos
        this.dtoAcompanhamento.exibeBotaoBoleto = false;
      }else{
          if (this.dtoAcompanhamento.boletoVencido) {//Verificando o vencimento do boleto
            this.dtoAcompanhamento.exibeBotaoBoleto= false;
         	}else{
        		if (this.dtoAcompanhamento.situacao == 'AGUARDANDO PAGAMENTO') {
              this.dtoAcompanhamento.exibeBotaoBoleto= true;
        		}else {
              this.dtoAcompanhamento.exibeBotaoBoleto= false;
        		};
        	}
      }

      //Sprint 102
      this.docs = this.fb.group({
        DocumentoCotista: this.fb.array(this.dtoAcompanhamento.documentos.map(
          documento => this.criarDocumento(documento,this.dtoAcompanhamento.indCotista,this.dtoAcompanhamento.indVista)
        ) || [])
      });

      this.utilService.showLoading(false);
    });
  }

  //Sprint 102
  criarDocumento(docCotista: Documentos,indCotista : boolean,indVista : boolean) {

    let situacaoDoc : string ='';

    if (indCotista == true){//Cotista
      if(indVista == true){//Liberou vista, deferimento ou indeferimento
        situacaoDoc = docCotista.situacao;
      }else{
        if(docCotista.situacao != 'Não Enviado'){
          situacaoDoc='Enviado';
        } else{
          situacaoDoc = docCotista.situacao;
        }
      } 
    }

    return this.fb.group({
        codDoc: docCotista.codDoc ,
        descDoc: docCotista.descDoc,
        fileBase64: docCotista.fileBase64,
        nomeArquivo: docCotista.nomeArquivo,
        idGed: docCotista.idGed,
        situacao: situacaoDoc,
        motivoRejeicao: docCotista.motivoRejeicao,
        urlGedDownload: docCotista.urlGedDownload,
        versaoDocGed : docCotista.versaoDocGed
    });
  }

  imprimirBoletoBinario(){
    this.utilService.showLoading();
      this.objServiceApi.retornaBoletoBinario(this.dtoAcompanhamento.cpf,
                                              this.dtoAcompanhamento.inscricao)
      .subscribe(
        (res) => {          
          const nameRel = 'boleto_' + this.dtoAcompanhamento.inscricao;
          res.filename = nameRel + '.pdf';
          const byteCharacters = atob(res.fileContents);
          const byteNumbers = new Array(byteCharacters.length);
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          const byteArray = new Uint8Array(byteNumbers);
          const blob = new Blob([byteArray], { type: `application/pdf` });
          this.filesaverservice.save(blob, res.filename);
          this.utilService.showLoading(false);
        },
        error => {
          this.utilService.showLoading(false);
          window.alert(error);
        }
      );
  }

    downloadDoc(url : string){
      let a= document.createElement('a');
          a.target= '_blank';
          a.href= url;
          a.click();
    }

  imprimirAcompanhamento(){
    window.self.print();
  }

  abrirPopUpMotivo(texto : string) {
    this.toastr.error(texto);
  }

  getClassSituacao(motivo : string){
    let classe : string ='fw-normal text-center backgroundColor border p-lf-2px ';
    if(motivo == 'REJEITADO'){
      classe=classe + 'text-danger';
    }else if(motivo == 'ACEITO'){
      classe=classe+'text-primary';
    }else{
      classe=classe+'text-black';
    }
    return classe;
  }
}
